import { useMemo, useState } from 'react';
import { ScrollView, SelectBox, TabPanel } from 'devextreme-react';
import { Item as TabItem } from 'devextreme-react/tab-panel';
import ReactMarkdown from 'react-markdown';
import { ToolbarSimple } from '../../components';
import './AboutSynerLab.scss';
import { APP_VERSIONS, AppVersion } from './versions.app';
import { CORE_VERSIONS, CoreVersion } from './versions.core';

type AnyVersion = AppVersion | CoreVersion;

const buildMarkdown = (version: AnyVersion): string => {
  const header = `# Versión ${version.version}${version.releaseDate ? `\n\n_Fecha de publicación: ${version.releaseDate}_` : ''}\n\n## Cambios\n`;
  const body = version.changes.map((c) => `- ${c}`).join('\n');
  return `${header}\n${body}`;
};

const VersionPanel = ({ versions }: { versions: AnyVersion[] }) => {
  const sortedDesc = useMemo(
    () => [...versions].sort((a, b) => b.version.localeCompare(a.version, undefined, { numeric: true })),
    [versions]
  );
  const latest = sortedDesc[0];
  const [selected, setSelected] = useState<string>(latest?.version);

  const current = useMemo(() => sortedDesc.find((v) => v.version === selected) ?? latest, [sortedDesc, selected, latest]);

  return (
    <div className='about-version-panel'>
      <div className='about-version-toolbar'>
        <label className='about-version-label'>Versión</label>
        <SelectBox
          dataSource={sortedDesc}
          displayExpr='version'
          valueExpr='version'
          value={selected}
          onValueChanged={(e) => setSelected(e.value)}
          width={200}
          stylingMode='outlined'
        />
        <span className='about-version-tag'>Instalada: {latest?.version}</span>
      </div>
      <div className='about-version-content dx-card'>
        {current ? <ReactMarkdown>{buildMarkdown(current)}</ReactMarkdown> : <em>No hay información disponible.</em>}
      </div>
    </div>
  );
};

const AboutSynerLab = () => {
  return (
    <div className='view crm-contact-list about-synerlab'>
      <div className='view-wrapper view-wrapper-contact-list'>
        <ScrollView className='view-wrapper-scroll'>
          <ToolbarSimple title='Acerca de SynerLab'>
            <TabPanel className='about-synerlab-tabs' defaultSelectedIndex={0} animationEnabled={true} swipeEnabled={false}>
              <TabItem title='APP'>
                <VersionPanel versions={APP_VERSIONS} />
              </TabItem>
              <TabItem title='CORE'>
                <VersionPanel versions={CORE_VERSIONS} />
              </TabItem>
            </TabPanel>
          </ToolbarSimple>
        </ScrollView>
      </div>
    </div>
  );
};

export default AboutSynerLab;
